import { ApiError } from '@/shared/api/api-client/api-error';
import { API_ACCOUNT_NOTIFICATIONS_READ_ALL } from '@/shared/constants/bff-endpoints';


export async function markAllNotificationsRead (): Promise<{ success: boolean; updated_count: number }> {
    const res = await fetch(API_ACCOUNT_NOTIFICATIONS_READ_ALL, { method: 'POST' });

    if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));

        throw new ApiError(res.status, errorData);
    }

    return res.json();
}
